<template>
    <!-- 封装主題切換弹窗 -->
    <el-dialog title="主題切換" :visible.sync="visible" :width="this.IsMobile() != null ? '96%' : '37%'" top="0vh"
        v-if="visible" append-to-body custom-class="center-dialog" ref="myDialog">
        <el-form size="small" :inline="true" label-position="left">
            <el-row>
                <el-form-item label="頂部欄预设主題">
                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-for="item in color_List" :key="item.bgcolor">
                        <div class="takecolorCss"
                            :style="{ background: item.bgcolor, color: item.color, cursor: 'pointer' }"
                            @click="set_color(item.bgcolor, item.color, 2)">
                            <span class="theme_font" :name="`nav_theme_${item.bgcolor}`"></span>
                        </div>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="菜單预设主題">
                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-for="item in color_List" :key="item.bgcolor">
                        <div class="takecolorCss"
                            :style="{ background: item.bgcolor, color: item.color, cursor: 'pointer' }"
                            @click="set_color(item.bgcolor, item.color, 1)">
                            <span class="theme_font" :name="`menu_theme_${item.bgcolor}`"></span>
                        </div>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row v-if="false">
                <el-form-item label="頁面内容预设主題">
                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-for="item in color_List" :key="item.bgcolor">
                        <div class="takecolorCss"
                            :style="{ background: item.bgcolor, color: item.color, cursor: 'pointer' }"
                            @click="set_color(item.bgcolor, item.color, 3)">
                            <span class="theme_font" :name="`body_theme_${item.bgcolor}`"></span>
                        </div>
                    </el-col>
                </el-form-item>
            </el-row>
            <el-row v-if="false">
                <el-form-item label="頁面交叉行主題">
                    <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-for="item in color_List" :key="item.bgcolor">
                        <div class="takecolorCss"
                            :style="{ background: item.bgcolor, color: item.color, cursor: 'pointer' }"
                            @click="set_color(item.bgcolor, item.color, 4)">
                            <span class="theme_font" :name="`striped_theme_${item.bgcolor}`"></span>
                        </div>
                    </el-col>
                </el-form-item>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" type="primary" @click="common_yes">確定</el-button>
            <el-button size="medium" @click="visible = false">退出</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { SaveSystem_theme } from "@/api/rms86/setup_system_theme";
export default {
    inject: ['reload'],
    data() {
        return {
            // 遮罩层
            visible: false,
            btnSure: false,
            last_menu_theme_content: "",//上次選中菜單主題
            last_nav_theme_content: "",//上次選中頂部欄主題
            last_body_theme_content: "",
            last_body_theme_striped_content: "",
            current_selected_menu_theme: this.$store.getters.current_menu_theme.background === undefined ? { "background": "#304156", "color": "rgb(191, 203, 217)" } : this.$store.getters.current_menu_theme,//當前選中菜單主題
            current_selected_nav_theme: this.$store.getters.current_nav_theme.background === undefined ? { "background": "#3c8dbc", "color": "#fff" } : this.$store.getters.current_nav_theme,//當前選中頂部欄主題
            current_selected_body_theme: this.$store.getters.current_body_theme.background === undefined ? { "background": "#ffffff", "color": "#606266" } : this.$store.getters.current_body_theme,//當前選中頂部欄主題
            current_selected_body_theme_striped: this.$store.getters.current_body_theme_striped.background === undefined ? { "background": "#6c757d", "color": "#fff" } : this.$store.getters.current_body_theme_striped,//當前選中頂部欄主題
            color_List: [
                { "bgcolor": "#ffffff", "color": "#606266" },
                { "bgcolor": "#007bff", "color": "#fff" },
                { "bgcolor": "#6c757d", "color": "#fff" },
                { "bgcolor": "#17a2b8", "color": "#fff" },
                { "bgcolor": "#28a745", "color": "#fff" },
                { "bgcolor": "#dc3545", "color": "#fff" },
                { "bgcolor": "#6f42c1", "color": "#fff" },
                { "bgcolor": "#e83e8c", "color": "#fff" },
                { "bgcolor": "#304156", "color": "#bfcbd9" },
                { "bgcolor": "#3c8dbc", "color": "#fff" },
                { "bgcolor": "#42b983", "color": "#fff" },
                { "bgcolor": "#343a40", "color": "#fff" }],
        };
    },
    methods: {
        // 显示弹框
        show() {
            this.visible = true;
        },
        // 選中默認設定顏色
        set_color(back_color, fore_color, type) {
            if (type === 1) {
                // 選擇當前背景時賦值
                if (this.last_menu_theme_content != "")
                    document.getElementsByName("menu_theme_" + this.last_menu_theme_content)[0].innerText = ""
                document.getElementsByName("menu_theme_" + this.menu_theme.background)[0].innerText = ""
                document.getElementsByName("menu_theme_" + back_color)[0].innerText = "已選"
                this.current_selected_menu_theme = { "background": back_color, "color": fore_color }
                this.last_menu_theme_content = back_color;
            }
            else if (type === 2) {
                if (this.last_nav_theme_content != "")
                    document.getElementsByName("nav_theme_" + this.last_nav_theme_content)[0].innerText = ""
                document.getElementsByName("nav_theme_" + this.nav_theme.background)[0].innerText = ""
                document.getElementsByName("nav_theme_" + back_color)[0].innerText = "已選"
                this.current_selected_nav_theme = { "background": back_color, "color": fore_color }
                this.last_nav_theme_content = back_color;
            }
            else if (type === 3) {
                if (this.last_body_theme_content != "")
                    document.getElementsByName("body_theme_" + this.last_body_theme_content)[0].innerText = ""
                document.getElementsByName("body_theme_" + this.body_theme.background)[0].innerText = ""
                document.getElementsByName("body_theme_" + back_color)[0].innerText = "已選"
                this.current_selected_body_theme = { "background": back_color, "color": fore_color }
                this.last_body_theme_content = back_color;
            }
            else {
                if (this.last_body_theme_striped_content != "")
                    document.getElementsByName("striped_theme_" + this.last_body_theme_striped_content)[0].innerText = ""
                document.getElementsByName("striped_theme_" + this.body_theme_striped.background)[0].innerText = ""
                document.getElementsByName("striped_theme_" + back_color)[0].innerText = "已選"
                this.current_selected_body_theme_striped = { "background": back_color, "color": fore_color }
                this.last_body_theme_striped_content = back_color;
            }
        },
        // 確認
        common_yes() {
            this.btn_sure = true;
            this.visible = false;
            // 保存主题到system_theme表
            var g_data = {
                menu_theme: JSON.stringify(this.current_selected_menu_theme),
                nav_theme: JSON.stringify(this.current_selected_nav_theme),
                body_theme: JSON.stringify(this.current_selected_body_theme),
                body_theme_striped: JSON.stringify(this.current_selected_body_theme_striped),
                font_type: this.$store.getters.size || "Medium"
            }
            SaveSystem_theme(g_data).then((data) => {
                // 保存成功提示
                if (data.success === 1) {
                    this.$message({
                        type: "success",
                        message: data.message,
                    });
                    // 更新到store中
                    this.$store.commit("set_menu_theme", this.current_selected_menu_theme);
                    this.$store.commit("set_nav_theme", this.current_selected_nav_theme);
                    this.$store.commit("set_body_theme", this.current_selected_body_theme);
                    this.$store.commit("set_body_theme_striped", this.current_selected_body_theme_striped);
                    this.reload();
                }
                // 失败异常提示
                else {
                    this.loading = false;
                    this.$message({
                        type: "danger",
                        message: data.message,
                    });
                }
            });
        },
        // 通用主题设置顶部
        set_theme(obj) {
            var container = this.$refs.myDialog;
            if(container) {
                var element = container.$el.querySelectorAll(obj);
                for (var i = 0; i < element.length; i++) {
                    element[i].style.backgroundColor = this.nav_theme["background"];
                    element[i].style.color = this.nav_theme["color"];
                }
            }
        },
    },
    updated() {
        this.SetFontSize(this.$store.getters.size);
        this.$nextTick(() => {
            // 弹窗主题
            this.set_theme(".el-dialog__header");
        });


        // 頁面加載時讀取緩存主題(這裡讀取theme.js中主題)
        if (document.getElementsByName("menu_theme_" + this.menu_theme.background).length != 0) {
            document.getElementsByName("menu_theme_" + this.menu_theme.background)[0].innerText = "已選"
        }
        if (document.getElementsByName("nav_theme_" + this.nav_theme.background).length != 0)
            document.getElementsByName("nav_theme_" + this.nav_theme.background)[0].innerText = "已選"

        if (document.getElementsByName("body_theme_" + this.body_theme.background).length != 0)
            document.getElementsByName("body_theme_" + this.body_theme.background)[0].innerText = "已選"
        if (document.getElementsByName("striped_theme_" + this.body_theme_striped.background).length != 0)
            document.getElementsByName("striped_theme_" + this.body_theme_striped.background)[0].innerText = "已選"
    },
    computed: {
        // 導航主題
        nav_theme() {
            return this.$store.getters.current_nav_theme.background === undefined ? { "background": "#3c8dbc", "color": "#fff" } : this.$store.getters.current_nav_theme;
        },
        //  菜單主題
        menu_theme() {
            return this.$store.getters.current_menu_theme.background === undefined ? { "background": "#304156", "color": "rgb(191, 203, 217)" } : this.$store.getters.current_menu_theme;
        },
        //  菜單主題
        body_theme() {
            return this.$store.getters.current_body_theme.background === undefined ? { "background": "#ffffff", "color": "#606266" } : this.$store.getters.current_body_theme;
        },
        body_theme_striped() {
            return this.$store.getters.current_body_theme_striped.background === undefined ? { "background": "#6c757d", "color": "#fff" } : this.$store.getters.current_body_theme_striped;
        },
    },
};
</script> 

<style lang="less" scoped>
/deep/.el-form-item__label {
    padding: 0px 12px 0px 9px;
}

/deep/.el-dialog__body {
    margin-left: -10px;
}

/deep/.el-dialog__header {
    border-bottom: 1px solid #DCDFE6;
}

/deep/.el-dialog__footer {
    border-top: 1px solid #DCDFE6;
    margin-top: 10px;
}

.container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    height: 40px;
    overflow-y: auto;
}

/* 移除颜色图标*/
.el-icon-arrow-down {
    display: none;
}

/* 移除清空按鈕*/
.theme-picker-dropdown-font,
.theme-picker-dropdown {
    z-index: 99999 !important;
}

.theme-picker /deep/.el-color-picker__trigger {
    height: 52px;
    width: 124px;
    padding: 2px;
    display: block;
}

.theme-picker-font /deep/.el-color-picker__trigger {
    height: 52px;
    width: 124px;
    padding: 2px;
    display: none;
}

.theme-picker-dropdown-font .el-color-dropdown__link-btn {
    display: none;
}

.theme-picker-dropdown .el-color-dropdown__link-btn {
    display: none;
}

.takecolorCss {
    position: relative;
    text-align: left;
    height: 52px;
    width: 52px;
    border-radius: 100%;
    margin-top: 10px;
    margin-left: 10px;
    border: 1px solid #b6b8ba;
}

.fontCss {
    position: absolute;
    margin-left: 4px;
    z-index: 1;
}

.theme_font {
    line-height: 52px;
    text-align: center;
    display: block;
}
</style>